import * as React from "react";
import { useSelector } from "react-redux";
import {
  useGetFilteredTodosQuery,
  useChangeStatusOrPriorityOrTextMutation,
} from "../features/api/apiSlice";
import Todo from "./Todo";
// import TodoLoader from "./ui/TodoLoader";
import cancelImage from "../assets/images/cancel.png";
import tickImage from "../assets/images/tick.png";

export default function TodoList() {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState("");
  const [id, setId] = React.useState(null);
  const { status, color } = useSelector((state) => state.filter);
  const { data, isLoading, isError, isSuccess } = useGetFilteredTodosQuery({
    status,
    color,
  });

  const [changeMultipleTodoStatus] = useChangeStatusOrPriorityOrTextMutation();

  const handleStatusOrPriorityOrTextChange = ({ id, data, changeProperty }) => {
    changeMultipleTodoStatus({
      id,
      body: {
        [changeProperty]: data,
      },
    });
  };

  const handleSubmit = () => {
    handleStatusOrPriorityOrTextChange({
      id,
      data: text,
      changeProperty: "text",
    });
    setOpen(false);
    setText("");
    setId(null);
  };
  console.log(id, text, open);
  const handleModalOpen = (value, todoTitle, id) => {
    setOpen(value);
    setText(todoTitle);
    setId(id);
  };

  const handleModalClose = () => {
    console.log("closed");
    setOpen(false);
    setText("");
    setId(null);
  };
  let content;
  if (isLoading) content = <p>Loading...</p>;
  if (!isLoading && isError)
    content = <p>Some thing went wrong ,please try again later</p>;
  if (isSuccess && data.length === 0) content = <p>No todos to show</p>;
  if (isSuccess && data.length > 0) {
    content = data.map((todo) => (
      <Todo handleModalOpen={handleModalOpen} key={todo.id} todo={todo} />
    ));
  }
  return (
    <>
      <div className=" flex flex-col mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
        {content}
      </div>
      <div
        className={`absolute flex items-center justify-center bg-black/10 w-screen	 h-screen	top-0 left-0 ease-in duration-300 ${
          !open ? "hidden" : ""
        }`}
      >
        <div className="px-8 relative flex items-center justify-between w-[500px] h-[80px] bg-white">
          <input
            value={text}
            onChange={(e) => setText(e.target.value)}
            className=" w-[400px] h-[30px] bg-slate-200 border-none rounded-lg  p-2"
          />
          <img
            src={tickImage}
            className="w-6 h-6  cursor-pointer "
            alt="ok"
            onClick={handleSubmit}
          />
          <img
            src={cancelImage}
            onClick={handleModalClose}
            className=" absolute top-0 right-0 flex-shrink-0 w-4 h-4 ml-2 cursor-pointer "
            alt="Cancel"
          />
        </div>
      </div>
    </>
  );
}
